import { Component, Inject, OnInit } from '@angular/core';

import { ConfigService } from 'src/app/services/config-service/config.service';
import {
  ActivatedRoute,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterState,
} from '@angular/router';
import { Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { MixpanelService } from '../../services/mixpanel-service/mixpanel.service';
import { LoginService } from '../../services/login-service/login.service';

declare const gtag: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  title = 'trinity-rail-marketplace';
  showHeader = true;
  loadingDataImg = false;
  constructor(
    public configService: ConfigService,
    private router: Router,
    private titleService: Title,
    @Inject(DOCUMENT) private document: Document,
    private mixpanelService: MixpanelService,
    private loginService: LoginService
  ) {
    router.events.subscribe((event) => {
      this.navigationInterceptor(event);
    });

    //Add dynamic title for selected pages - Start
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const title = this.getTitle(
          router.routerState,
          router.routerState.root
        ).join(' > ');
        titleService.setTitle(title);
      }
    });

    configService._config_$.subscribe((configUrls) => {
      localStorage.setItem('config-service', JSON.stringify(configUrls));
    });
  }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.showHeader = event.url !== '/';
      }
    });
    this.setUpAnalytics();
    if (this.loginService.isSessionValid()) {
      this.loginService.getUserEmail()?.subscribe({
        next: (email: string) => {
          localStorage.setItem('userEmail', email);
          this.mixpanelService.init(email);
        },
        error: (err) => {
          console.error(err);
        },
      });
    }
  }

  setUpAnalytics() {
    /** START : Code to Track Page View using gtag.js */
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const title = this.getTitle(
          this.router.routerState,
          this.router.routerState.root
        ).join('-');
        this.titleService.setTitle(title);
        gtag('event', 'page_view', {
          page_title: title,
          page_path: event.urlAfterRedirects,
          page_location: this.document.location.href,
        });
      }
    });
  }

  // collect that title data properties from all child routes
  getTitle(state: RouterState, parent: ActivatedRoute): string[] {
    const data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data['title']) {
      data.push(parent.snapshot.data['title']);
    }
    if (state && parent && parent.firstChild) {
      data.push(...this.getTitle(state, parent.firstChild));
    }
    return data;
  }

  // Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: any): void {
    //Triggered When the navigation starts
    if (event instanceof NavigationStart) {
      this.loadingDataImg = true;
    }
    //Triggered When the navigation ends
    if (event instanceof NavigationEnd) {
      this.loadingDataImg = false;
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.loadingDataImg = false;
    }
    //Triggered When the error occurrs while navigation
    if (event instanceof NavigationError) {
      this.loadingDataImg = false;
    }
  }
}
